import { gql } from '@provision/graphql-client';
import { META_DATA_QUERY_FIELDS } from 'src/graphql/entities/metadata.fragments';
import {
  WORKFLOW_ASSIGNMENT_FIELDS,
  WORKFLOW_FIELDS,
  WORKFLOW_STEP_FIELD_FIELDS,
  WORKFLOW_VERSION_FIELDS,
} from './workflow.fragments';

export const GET_WORKFLOWS_QUERY = gql`
  query GetWorkflows($params: QueryParams, $skipTotalRecords: Boolean = false)
  @entity(name: "Workflow") {
    getWorkflow(queryParams: $params) {
      records {
        ...WorkflowFields
      }
      metadata {
        ...MetaDataQueryFields
      }
    }
  }
  ${WORKFLOW_FIELDS}
  ${META_DATA_QUERY_FIELDS}
`;

export const GET_WORKFLOW_VERSIONS_QUERY = gql`
  query GetWorkflowVersions($params: QueryParams, $skipTotalRecords: Boolean = false)
  @entity(name: "WorkflowVersion") {
    getWorkflowVersion(queryParams: $params) {
      records {
        ...WorkflowVersionFields
      }
      metadata {
        ...MetaDataQueryFields
      }
    }
  }
  ${WORKFLOW_VERSION_FIELDS}
  ${META_DATA_QUERY_FIELDS}
`;

export const GET_WORKFLOW_ASSIGNMENTS_QUERY = gql`
  query GetWorkflowAssignments($params: QueryParams, $skipTotalRecords: Boolean = false)
  @entity(name: "WorkflowAssignment") {
    getWorkflowAssignment(queryParams: $params) {
      records {
        ...WorkflowAssignmentFields
      }
      metadata {
        ...MetaDataQueryFields
      }
    }
  }
  ${WORKFLOW_ASSIGNMENT_FIELDS}
  ${META_DATA_QUERY_FIELDS}
`;

export const GET_WORKFLOW_STEP_TYPES_QUERY = gql`
  query GetWorkflowStepTypes {
    getWorkflowStepTypes {
      stepTypes {
        type
        label
        description
        isTrigger
        triggerTypes
        result
        outputs {
          key
          label
          condition
        }
        # Three levels: enqueueForAgent's waitMenu (GROUP) holds voicemail / callback
        # (BOOLEAN_OR_CONDITION), whose own fields are the condition.
        fields {
          ...WorkflowStepFieldFields
          fields {
            ...WorkflowStepFieldFields
            fields {
              ...WorkflowStepFieldFields
            }
          }
        }
      }
      triggerTypes {
        type
        label
      }
    }
  }
  ${WORKFLOW_STEP_FIELD_FIELDS}
`;
